import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Logo } from "@/components/Logo";
import { LangToggle } from "@/components/LangToggle";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export default function Corporate() {
  const { t } = useApp();
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings/public").then(({ data }) => setS(data)).catch(() => setS({})); }, []);
  if (!s) return null;

  const rows = [
    [t("registered_company"), s.company_name],
    [t("company_no"), s.companies_house_number],
    [t("registered_office"), s.registered_office],
    [t("official_email"), s.official_email],
    [t("website"), s.website],
  ].filter(([, v]) => v);

  const legal = [
    [t("membership_terms"), s.terms_membership],
    [t("terms_conditions"), s.terms_conditions],
    [t("privacy_policy"), s.privacy_policy],
    [t("cookie_info"), s.cookie_info],
  ].filter(([, v]) => v);

  return (
    <div className="min-h-screen flex flex-col">
      <header className="flex items-center justify-between px-6 pt-6">
        <Link to="/" className="eyebrow hover:text-[color:var(--cu-gold-light)]">← Caught Up</Link>
        <LangToggle />
      </header>
      <div className="flex-1 px-6 py-10 max-w-2xl mx-auto w-full fade-up">
        <Logo size="md" />
        <h1 className="font-serif-cu text-3xl text-center mt-10 mb-10">{t("corporate_info")}</h1>

        <div className="cu-card p-6 space-y-4" data-testid="corporate-company-info">
          {rows.map(([label, value]) => (
            <div key={label} className="flex justify-between gap-4 border-b border-[color:var(--cu-border)] last:border-0 pb-3 last:pb-0">
              <span className="eyebrow">{label}</span>
              <span className="text-sm text-[color:var(--cu-text)] text-right">{value}</span>
            </div>
          ))}
        </div>

        <div className="mt-8">
          <Accordion type="single" collapsible className="cu-card px-5" data-testid="corporate-legal-accordion">
            {legal.map(([label, value], i) => (
              <AccordionItem key={label} value={`item-${i}`} className="border-[color:var(--cu-border)]">
                <AccordionTrigger className="text-sm font-serif-cu text-[color:var(--cu-gold-light)] hover:no-underline">{label}</AccordionTrigger>
                <AccordionContent className="text-sm text-[color:var(--cu-muted)] leading-relaxed">{value}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="mt-10 text-center">
          <div className="eyebrow mb-4">{t("contact")}</div>
          <WhatsAppButton />
        </div>

        <p className="text-[0.65rem] text-[color:var(--cu-muted)] mt-12 text-center tracking-[0.15em] font-mono-cu">© 2026 CAUGHTUP.INTERNATIONAL · {t("all_rights").toUpperCase()}</p>
      </div>
    </div>
  );
}
